/* Preserve native originals. Replace only this rejected image with its verified White product flat. */
(() => {
  const rejected = 'marcel-afters-classic-knit-polo-white-model-01';
  const fallback = 'https://marcelafters.com/cdn/shop/files/c5ae9bed37714c9ba2be41b99bfa40ed.png?v=1790318599&width=864';
  const repair = (root) => {
    const images = root instanceof HTMLImageElement ? [root] : root.querySelectorAll?.('img') || [];
    for (const image of images) {
      if (!`${image.getAttribute('src') || ''} ${image.getAttribute('srcset') || ''}`.includes(rejected)) continue;
      const picture = image.closest('picture');
      picture?.querySelectorAll('source').forEach(source => {
        if ((source.getAttribute('srcset') || '').includes(rejected)) source.removeAttribute('srcset');
      });
      image.removeAttribute('srcset');
      image.src = fallback;
      if (image.alt) image.alt = 'Classic Knit Polo in White, front view';
    }
  };
  repair(document);
  new MutationObserver(records => {
    for (const record of records) {
      if (record.type === 'attributes') repair(record.target);
      else record.addedNodes.forEach(node => { if (node.nodeType === 1) repair(node); });
    }
  }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['src', 'srcset'] });
})();
